import { type RouteRecordRaw } from 'vue-router';

import { ROUTE_DATA } from '@/constants/routes.constants';

const ContactHub = (): unknown => {
    return import(/* webpackPrefetch: true */ './contact-hub-page.vue');
};

export const contactHubRoute: RouteRecordRaw = {
    ...ROUTE_DATA.CONTACT_HUB_PAGE,
    components: {
        main: ContactHub
    }
};
